import { MastraClient } from "@mastra/client-js";

export const mastraClient = new MastraClient({
  baseUrl: `${import.meta.env.VITE_DOMAIN_API}/api/mastra`,
  credentials: "include",
  apiPrefix: "",
});
